"use client";

import { TimelineContainer } from "./timeline-container";
import { CarHireItineraryInner } from "./car-hire-itinerary-inner";
import { iCarHireLegDetails } from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";

export function CarHireItinerary(
  props: iCarHireLegDetails & { primaryColor?: string; day: number }
) {
  return (
    <TimelineContainer
      title={props.title || "Car Hire"}
      icon={(props.icon as any) || "car"}
    >
      <CarHireItineraryInner {...props} day={props.day} />
    </TimelineContainer>
  );
}
